'use strict';

import React from 'react';

import { OnSchedRest } from "../../OnSchedRest";
import { OnSchedUtils } from "../../utils";
import PageNumber from "./PageNumber/PageNumber";


const Pagination = ({ element, response, setResponse }) => {
  const { CustomEvents, GetEventType, Loading } = OnSchedUtils;
  
  const [total, setTotal] = React.useState(1);
  const [pageNumbers, setPageNumbers] = React.useState([]);
  const [active, setActive] = React.useState(1);
  const [count, setCount] = React.useState(0);
  const [callbackUrl, setCallbackUrl] = React.useState('');
  
  const fwdBackColorScheme = 'onsched-shadow-background-color onsched-secondary-background-color-hover onsched-dark-color onsched-pimary-color-hover';

  let callback = response => {
    setResponse(response);
    
    CustomEvents(element.id, GetEventType(element, 'GET'), response);
    
    Loading(element, false);
  };
  
  React.useEffect(() => { 
    if (response?.total && response?.url) {
      setResponse(response);
      // Set total pages
      setTotal(Math.ceil(response.total/(element.params.limit ? element.params.limit : 20)));

      // Set count per page
      setCount((element.params.limit ? element.params.limit : 20));
      
      // Set active page if offset param provided
      if (element.params.offset) {
        setActive(Math.floor(element.params.offset/(element.params.limit ? element.params.limit : 20)) + 1);
      }
      
      // Format URL for callback
      setCallbackUrl(element.onsched.jsApiBaseUrl + response.url.replace('/v1', ''));
    }
  }, [response]);

  React.useEffect(() => {
    let newPageNumbers = [];

    for (let i = 1; i <= total; i++) {
      newPageNumbers.push(i);
    };

    setPageNumbers(newPageNumbers);
  }, [total])

  // React.useEffect(() => {
  //   if (data?.total && data?.url) {
  //     // Set total pages
  //     setTotal(Math.ceil(data.total/(element.params.limit ? element.params.limit : 20)));

  //     // Set count per page
  //     setCount((element.params.limit ? element.params.limit : 20));
      
  //     // Set active page if offset param provided
  //     if (element.params.offset) {
  //       setActive(Math.floor(element.params.offset/(element.params.limit ? element.params.limit : 20)) + 1);
  //     }
      
  //     // Format URL for callback
  //     setCallbackUrl(element.onsched.jsApiBaseUrl + data.url.replace('/v1', ''));
  //   }
  // }, [data]);

  const selectPage = page => {
    OnSchedUtils.Loading(element, true);
    
    const offset = page * count - count;
    let params = element.params;
    params.offset = offset;

    const url = OnSchedUtils.FormatUrlParams(callbackUrl, params);

    if (page > 0) {
      setActive(page);
    }
    else {
      setActive(1);
    }

    OnSchedRest.Get(url, response => {
      callback(response);
    });
  }

  return (
    <div className="Pagination">
      {active > 3 &&
        <button 
          className={`PageNumber available pagination-first ${fwdBackColorScheme}`} 
          onClick={() => selectPage(1)}
        ></button>
      }
      {active > 1 &&
        <button 
          className={`PageNumber available pagination-back ${fwdBackColorScheme}`} 
          onClick={() => selectPage(active - 1)}
        ></button>
      }
      {pageNumbers?.length > 1 && pageNumbers.map((page, idx) => 
        <PageNumber 
          key={idx} 
          page={page} 
          active={active}
          callback={() => selectPage(page)}
        />
      )}
      {active < total &&
        <button 
        className={`PageNumber available pagination-next ${fwdBackColorScheme}`} 
        onClick={() => selectPage(active + 1)}
        ></button>
      }
      {active < (total - 2) &&
        <button 
          className={`PageNumber available pagination-last ${fwdBackColorScheme}`} 
          onClick={() => selectPage(total)}
        ></button>
      }
    </div>
  );
}

export default Pagination
